import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'; 
import axiosInstance from "../utils/axiosInstance";
import './profile.css';
import profile_pic from '../images/profile-pic.png';
import axios from 'axios'; 

function Profile({ user, setUser }) {
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_ENV;
    // Always call useState hooks unconditionally
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        firstName: user?.first_name || '',
        lastName: user?.last_name || '',
        email: user?.email || '',
        password: "********",
        phone: user?.phone || '',
        gender: user?.gender || '',
    });

    // Only run the useEffect if the user is not null
    useEffect(() => {
        if (!user) {
            navigate('/login');
        } else {
            const fetchUser = async () => {
                try {
                    const response = await axiosInstance.get(`${API_URL}/me`);
                    const updatedUser = response.data;
    
                    setFormData({
                        firstName: updatedUser.first_name || '',
                        lastName: updatedUser.last_name || '',
                        email: updatedUser.email || '',
                        password: "********",
                        phone: updatedUser.phone || '',
                        gender: updatedUser.gender || '',
                    });
                } catch (err) {
                    console.error("Failed to fetch user", err);
                }
            };
    
            fetchUser();
        }
    }, [user, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const toggleEdit = () => {
        setEditMode(prev => !prev);
    };

    const handleSave = async () => {
        try {
            const response = await axiosInstance.put(
                `${API_URL}/profile`,
                {
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    email: formData.email,
                    password: formData.password !== "********" ? formData.password : undefined,
                    phone: formData.phone,
                    gender: formData.gender
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log("Profile updated");
            setEditMode(false);  // Disable edit mode after save
        } catch (error) {
            console.error("Error saving profile:", error);
            alert("Failed to save changes.");
        }
    };

    if (!user) {
        return null; 
    }
    const handleDeleteAccount = async () => {
        const confirmDelete = window.confirm("Are you sure you want to delete your account?");
        if (!confirmDelete) return;
      
        try {
          const response = await axiosInstance.delete(`${API_URL}/delete-account/${user.id}`, {
            withCredentials: true
          });
      
          if (response.status === 200) {
            setUser(null);               // Clear local user state first
            alert("Account deleted successfully.");  // Alert second
            navigate('/signup');  
          } else {
            alert("Failed to delete account.");
          }
        } catch (error) {
          console.error(error);
          alert("An error occurred while deleting the account.");
        }
      };
    return (
        <div className='profile-bg'>
            <div className='profile-card'>
                <div className='profile-header'>
                    <div className="info-section">
                        <img src={profile_pic} alt="Profile" className="in-profile-picture" />
                        <div className="text-info">
                            <h2>{formData.firstName} {formData.lastName}</h2>
                            <p className='email'>{formData.email}</p>
                        </div>
                    </div>
                    <button onClick={editMode ? handleSave : toggleEdit} className="edit-btn">
                        {editMode ? "Save" : "Edit"}
                    </button>
                </div>
                <form className='profile-form'>
                    <div className='row'>
                        <div className='form-group'>
                            <label>First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className='form-group'>
                            <label>Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group'>
                            <label>Email</label>
                            <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className='form-group'>
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group'>
                            <label>Phone Number</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className='form-group'>
                            <label>Gender</label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                disabled={!editMode}
                            >
                                <option value="">{formData.gender}</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                </form>
                <div className = 'delete-account'>
                    <button 
                        type="button" 
                        className='delete-btn' 
                        onClick={handleDeleteAccount}
                    >
                        Delete Account
                    </button>
                    </div>
            </div>
        </div>
    );
}

export default Profile;
